'use client';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   disabled: boolean;
   hasOrderingPermission: boolean;
   onAddToCart: () => void;
}

export const QuoteAddToCartButton = ({ disabled, hasOrderingPermission, onAddToCart }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="xs">
         <Button leadingIcon="shopping-cart" fullWidth disabled={disabled} onClick={disabled ? undefined : onAddToCart}>
            {translate('prices.add-to-cart')}
         </Button>
         {!hasOrderingPermission && (
            <Typography variant="small" color="subtle">
               {translate('permissions.no-place-orders-permission')}
            </Typography>
         )}
      </Box>
   );
};
